import type { SupportedLocale } from '@brightdrop/localization-core';
import { useSyncExternalStore } from 'react';

import { getActiveOverride, subscribe } from './overrideStore';

/**
 * The language set from the browser console, while it is allowed to apply
 * @returns The override locale, or null when none applies
 */
const useLanguageOverride = (): SupportedLocale | null =>
  useSyncExternalStore(subscribe, getActiveOverride);

export default useLanguageOverride;
